import ApprovalConfigRepository from './ApprovalConfigRepository';
import ApprovalRepository from './ApprovalRepository';
import BrandRepository from './BrandRepository';
import CategoryRepository from './CategoryRepository';
import DebtRepository from './DebtRepository';
import InstallmentRepository from './InstallmentRepository';
import PlatformIntegrationRepository from './PlatformIntegrationRepository';
import ProductRevenueReportRepository from './ProductRevenueReportRepository';
import CustomerRepository from './CustomerRepository';
import ProviderRepository from './ProviderRepository';
import ShopeeAdminRepository from './ShopeeAdminRepository';
import StoreRepository from './StoreRepository';
import EmployeeRepository from './EmployeeRepository';
import VoucherRepository from './VoucherRepository';
import ShippingRepository from './ShippingRepository';

const repositories = {
  customers: CustomerRepository,
  brands: BrandRepository,
  categories: CategoryRepository,
  approvalConfigs: ApprovalConfigRepository,
  approvals: ApprovalRepository,
  debts: DebtRepository,
  installments: InstallmentRepository,
  platformIntegration: PlatformIntegrationRepository,
  productRevenueReport: ProductRevenueReportRepository,
  providers: ProviderRepository,
  shopeeAdmin: ShopeeAdminRepository,
  stores: StoreRepository,
  employees: EmployeeRepository,
  vouchers: VoucherRepository,
  shipping: ShippingRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
